<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { RecentProviderSearches, RecentFacilitySearches, RecentPracticeSearches } from '../../utils/local-storage.ts';
  import { trackEvent } from '../../utils/umami-events.js';

  let {
    clearResultTileButtonTextTemplate,
    name,
    url,
    subtitle,
    handleClearButtonClick,
    providerSearchType,
    dataTestId = 'provider-search-result-tile',
    focusCallback = () => {},
    blurCallback = () => {},
  } = $props();

  let RecentSearchesStore = RecentProviderSearches;
  
  if (providerSearchType === 'practice') {
    RecentSearchesStore = RecentPracticeSearches;
  } else if (providerSearchType === 'facility') {
    RecentSearchesStore = RecentFacilitySearches;
  }

  const clearButtonTextReplacePattern = /{{PROVIDER}}/;
</script>

<div class="relative w-full" data-testid={dataTestId}>
  <button
    onclick={() => {
      trackEvent(`${providerSearchType}-search-result-click`, { value: name });
      
      if (providerSearchType) {
        RecentSearchesStore.add({ name, subtitle, url });
      }
      window.location.href = url;
    }}
    onfocus={() => focusCallback()}
    onblur={() => blurCallback()}
    class="block w-full rounded-sm bg-white text-blue-navy shadow-y-sm pseudo-shadow-tight-hover active:shadow-active"
    aria-label={name}
  >
    <div class="w-full px-3 py-2 flex flex-col items-start">
      <div class="text-base text-left tracking-wider" aria-hidden="true">
        {@html name}
      </div>
      {#if subtitle}
        <div class="text-sm text-gray-charcoal" aria-hidden="true">
          {@html subtitle}
        </div>
      {/if}
    </div>
  </button>
  {#if handleClearButtonClick}
    <button
      class="absolute top-0 right-0 w-10 h-14 flex justify-center items-center text-gray-silver hover-hover:hover:text-gray-warm active:text-gray-warm
      focus:text-blue-darkish focus:outline-hidden"
      aria-label={clearResultTileButtonTextTemplate && clearResultTileButtonTextTemplate.replace(clearButtonTextReplacePattern, name)}
      data-testid="{dataTestId}-clear-button"
      onclick={() => handleClearButtonClick({ name, url })}
    >
      <svg class="w-4 h-4 fill-current rounded-full" role="presentation">
        <use xlink:href="{SPRITESHEET_URL}clear-x" />
      </svg>
    </button>
  {/if}
</div>
